import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { OrganizationDocument } from "../organization.types";

type Args = {
  organizationId: number;
  enabled?: boolean;
};

/**
 * Fetch logos for an organization.
 */
export function useFetchOrganizationLogos({
  organizationId,
  enabled = true,
}: Args) {
  return useQuery<OrganizationDocument[]>({
    queryKey: ["organization", organizationId, "logos"],
    queryFn: async () => {
      return await apiRequest(
        `/organization/${organizationId}/logos/`,
        "GET"
      );
    },
    enabled: enabled && !!organizationId,
  });
}

